import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  { year: 2018, count: 200000, trend: 300000 },
  { year: 2019, count: 600000, trend: 450000 },
  { year: 2020, count: 400000, trend: 600000 },
  { year: 2021, count: 1100000, trend: 850000 },
  { year: 2022, count: 1300000, trend: 1200000 },
  { year: 2023, count: 1500000, trend: 1900000 },
];

const GrowthChart = () => {
  return (
    <div
      className="container"
      style={{
        backgroundColor: "#fff",
        padding: "30px",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        position: "relative",
        maxWidth: "900px",
        marginTop: "50px",
      }}
    >
      {/* Heading */}
    <h2
  style={{
    textAlign: "center",
    fontWeight: 800,
    color: "#ff0000",
    marginBottom: "30px",
    textTransform: "uppercase",
    fontSize: "clamp(1.7rem, 5vw, 3rem)", // Responsive font size
  }}
  className="title split-collab text-danger"
>
  Our Growth Trajectory
</h2>


      {/* Chart */}
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={data}
          margin={{ top: 10, right: 40, left: 0, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#1f77ff"
            strokeWidth={4}
            name="TOTAL COUNT"
          />
          <Line
            type="monotone"
            dataKey="trend"
            stroke="#1f77ff"
            strokeDasharray="5 5"
            strokeWidth={3}
            name="Expon. (TOTAL COUNT)"
          />
        </LineChart>
      </ResponsiveContainer>

      {/* Growth Text */}
      <div
        style={{
          position: "absolute",
          top: "80px",
          right: "-20px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "10px 15px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          fontSize: "14px",
          maxWidth: "180px",
        }}
      >
        <div style={{ fontWeight: "600" }}>
          The growth percentage <br />
          from 2018 to 2023
        </div>
        <div style={{ marginTop: "10px", fontWeight: "600" }}>
          ={" "}
          <span style={{ color: "green", fontWeight: "700" }}>
            544.06 % (Approx)
          </span>
        </div>
      </div>
    </div>
  );
};

export default GrowthChart;
